import { config, isFeatureEnabled } from '@iheartjane/config';

export const useIsRoundingAmountDisplayed = (
  roundingAmount: string | number | null,
  storeId?: string | number
) => {
  const roundingDisplayEnabled =
    isFeatureEnabled('roundingDisplay') &&
    typeof storeId !== 'undefined' &&
    config.roundingBetaStoreIds.includes(parseInt(storeId.toString()));

  const HALF_PENNY = 0.005;

  const atLeastPennyRounded = Math.abs(Number(roundingAmount)) >= HALF_PENNY;

  return roundingDisplayEnabled && atLeastPennyRounded;
};
